<div class="main-content">
  <div class="container-fluid">
    <div class="meeting-step-header">
      <h4>Third Meeting</h4>
      <p class="meeting-step-subtitle">
        Schedule the next call, share the contact e-mail template, then mark the meeting as completed.
      </p>
    </div>

    <router-outlet *ngIf="!loading" name="meeting_3"></router-outlet>
  </div>
</div>
